// RectBlockoutsDialog.tsx — Up to 6 rectangular blockouts (sbvar)

import DialogBase from './DialogBase';
import { SlotEditor } from './SlotEditor';
import { usePendingSlot } from './usePendingSlot';
import { useShallowStore } from '../store/useStore';

const FIELDS = [
  { key: 'mark',   label: 'Mark',   type: 'text'   as const },
  { key: 'width',  label: 'Width',  type: 'number' as const, unit: '"', min: 0 },
  { key: 'height', label: 'Height', type: 'number' as const, unit: '"', min: 0 },
  { key: 'x',      label: 'X Ctr',  type: 'number' as const, unit: '"', min: 0 },
  { key: 'y',      label: 'Y Ctr',  type: 'number' as const, unit: '"', min: 0 },
];

export default function RectBlockoutsDialog() {
  const { ui, project, updatePanel } = useShallowStore(s => ({
    ui: s.ui, project: s.project, updatePanel: s.updatePanel,
  }));
  const panel = project?.panels.find(p => p.id === ui.activePanelId);
  const [slots, setSlots] = usePendingSlot('sbvar', panel?.sbvar ?? [],
    (px, py, mark) => ({ mark, x: px, y: py }),
    { mark: '', x: 0, y: 0, width: 24, height: 24, depth: 0 });
  if (!panel) return null;

  return (
    <DialogBase title="Rectangular Blockouts (6 max)" onOk={() => updatePanel(panel.id, { sbvar: slots })}>
      <SlotEditor
        slots={slots}
        fields={FIELDS}
        maxSlots={6}
        onChange={v => setSlots(v)}
        defaultData={() => ({ mark: '', x: 0, y: 0, width: 24, height: 24, depth: 0 })}
        label="SB"
      />
    </DialogBase>
  );
}
